// dependencies
import { List, Map } from "immutable";

export const getUserSearchResultsMap = (state) => state.getIn(["users", "ajaxQueries"], Map());
export const getUserSearchResults = (state, query) => state.getIn(["users", "ajaxQueries", query], List());
